import React from "react";
import styled from "@emotion/styled";
import parse from 'html-react-parser';
import { Accordion, Flex, MinusIcon, Text, Label, Button } from 'src/components';
import { CalculatorCoverageWithPriceDto, i18n, openCallMeModal, useAppDispatch } from "src/common";
import { colors } from "src/theme";
import { Card } from "./card";


const AccordionStyle = styled(Accordion)({
  padding: '4px'
})

const LabelStyle = styled(Label)({
  marginLeft: '8px',
})

const TextStyle = styled(Text)({
  marginLeft: '8px',
})


// const ButtonStyle = styled(Button)({
//   marginInline: '8px'
// })

interface AdditionalCoveragesCardProps {
  additionalCoverages: Array<CalculatorCoverageWithPriceDto>;
  expandable?: boolean;
  className?: string;
}

export const AdditionalCoveragesCard = ({ additionalCoverages, expandable = false, className }: AdditionalCoveragesCardProps) => {
  const dispatch = useAppDispatch();

  return (
    <Card radius={12} padding={10} background={colors.background6} className={className}>
      <Flex vertical gap={4}>
        <Card radius={4} padding={10}>
          <Accordion
            title={<Flex gap={8}>
              <LabelStyle type='small' color={colors.text4}>{i18n.t('components.cards.coveragesCard.additionalCoverages')}</LabelStyle>
            </Flex>}
            content={
              <Flex vertical gap={12}>
                {additionalCoverages.map((coverage, index) => (
                  <AccordionStyle
                    title={<TextStyle type='tiny' bold color={colors.text3}>{coverage.label}</TextStyle>}
                    content={<Text type='tiny' color={colors.text3}>{parse(coverage.description || '')}</Text>}
                    icon={<MinusIcon color={colors.success} />}
                    expandable={expandable}
                    expandIcon={expandable}
                    open={true}
                    key={index}
                  />))}
                <Button btnType="outlinePrimary" size="small" text="Zatraži poziv" onClick={() => dispatch(openCallMeModal())} />
              </Flex>
            }
            open={false}
          />
        </Card>
        {/* <Text type='tiny' color={colors.text3}>{i18n.t('components.cards.coveragesCard.notPossibleOnline')}</Text> */}
      </Flex>
    </Card >
  )
};
